import React,{useEffect} from "react";
import { useParams } from "react-router";
import FbDemoRegister from "../../components/BookDemo/fb/DemoRegister";
import DemoSchedule from "../../components/BookDemo/fb/DemoSchedule";
import SuccessMessage from "../../components/BookDemo/fb/SuccessMessage";
import { createjscssfile, initPixel } from "../../helpers/CampaignEvents";

const BookaDemo = () => {
  const { component } = useParams();

  useEffect(() => {
    initPixel()
    createjscssfile()
  }, [])

  return (
    <div className="bookdemo-root ">
      <div className="container">
        <div className="bookdemo">
          {component === "schedule-demo" ? (
            <DemoSchedule />
          ) : component === "success" ? (
            <SuccessMessage />
          ) : (
            <FbDemoRegister subject={component} />
          )}
        </div>
      </div>
    </div>
  );
};

export default BookaDemo;
